import { render, staticRenderFns } from "./FeedBackReciver.vue?vue&type=template&id=37eece08&scoped=true&"
import script from "./FeedBackReciver.vue?vue&type=script&lang=js&"
export * from "./FeedBackReciver.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackReciver.vue?vue&type=style&index=0&id=37eece08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eece08",
  null
  
)

export default component.exports